import React, { useState } from 'react';
import AppleLogin from '../../../../components/AppleLogin';
import GoogleLogin from '../../../../components/GoogleLogin';
import Button from '../../../../ui-core/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { LOCAL_STORAGE_CONSTANT, MODAL_TYPE } from '../../../../constants/app';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import EmailIcon from '../../../../static/images/signup/Email.svg';
import OpenEye from '../../../../static/images/signup/Openeye.svg';
import CloseEye from '../../../../static/images/signup/closeeye.svg';
import { doOtpRequest } from '../../../../store/action/auth';
import { extractJSON } from '../../../../services/jsonUtil';
import { APP_ROUTES } from '../../../../route';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getItem } from '../../../../utils/cache';
import { initiateJoinDeepLinkMembershipCheckout } from '../../../../utils/joinDeepLinkPurchase';

const EmailModal = props => {
  const { isLoading } = useSelector(state => state.common);
  const dispatch = useDispatch();
  const history = useHistory();
  const { handleModalState, processOfflineCart } = props;
  const [showPassword, setShowPassword] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        `You've entered an invalid email, please try another one.`,
      )
      .required('Please enter email.'),
    password: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .required('Password is required'),
  });

  const submit = async values => {
    const loginPayload = {
      email: values?.email,
      password: values?.password,
      email_signin: true,
    };

    dispatch(
      doOtpRequest({
        data: loginPayload,
        callback: () => {
          const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
          if (
            user?.attributes?.mobile === '' ||
            user?.attributes?.mobile === null ||
            user?.attributes?.mobile.includes('@')
          ) {
            handleModalState(MODAL_TYPE.PHONE);
          } else {
            const isRedirectCourse = getItem('redirectToCourse');
            if (isRedirectCourse && props?.handleClose) {
              props?.handleClose();
            } else {
              const isOfflineCheckout = JSON.parse(
                getItem('isOfflineCheckout'),
              );
              if (isOfflineCheckout && processOfflineCart) {
                processOfflineCart();
              } else {
                handleModalState(null);
                if (
                  !initiateJoinDeepLinkMembershipCheckout(dispatch, history)
                ) {
                  history.push(APP_ROUTES.HOME);
                }
              }
            }
          }
          // handleModalState(MODAL_TYPE.PHONE);
        },
        errorCallback: () => {
          handleModalState(MODAL_TYPE.EMAIL_LOGIN);
        },
      }),
    );
  };
  const { errors, handleSubmit, setFieldValue, touched } = useFormik({
    validationSchema,
    onSubmit: submit,
    initialValues: {
      email: '',
    },
  });

  return (
    <div className="form-h">
      <h1 className="login-h2">Login to your account</h1>
      <p className="login-h3 mb-4 mt-4 sub-heading-text">
        {' '}
        Please enter your details to access your account.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="email_input">
          <label htmlFor="email" className="text-uppercase sign_label">
            EMAIL ADDRESS
          </label>
          <div className="mt-2 email_input_text d-flex gap-0">
            <img src={EmailIcon} alt="email icon" />
            <input
              type="text"
              name="email"
              id="email"
              className="border-0 ms-2 w-100 sign_up_input"
              placeholder="Enter email"
              onChange={event => setFieldValue('email', event.target.value)}
            />
          </div>
          {!!errors?.email && !!touched?.email && (
            <span className="text-danger error-text">{errors?.email}</span>
          )}
        </div>
        {/* <div className="position-relative">
                    <span className="text-danger error-text text-center d-block w-100">
                        {error.hasError ? error.message : ''}
                    </span>
                </div> */}
        <div className="pass_input mt-4">
          <label htmlFor="password" className="text-uppercase sign_label">
            Enter Password
          </label>
          <div className="mt-2 pass_input_text">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              id="password"
              className="border-0 w-100 sign_up_input"
              placeholder="Enter password"
              onChange={event => setFieldValue('password', event.target.value)}
            />
            <div
              onClick={() => setShowPassword(!showPassword)}
              className="cursor-pointer"
            >
              {showPassword ? (
                <img src={OpenEye} alt="show icon" />
              ) : (
                <img src={CloseEye} alt="hide icon" />
              )}
            </div>
          </div>
          {!!errors?.password && !!touched?.password && (
            <div className="text-danger error-text">{errors?.password}</div>
          )}
        </div>
        <div
          className="text-center mt-5 forgot-password-text cursor-pointer"
          onClick={() => handleModalState(MODAL_TYPE.RESET_PASSWORD)}
        >
          Forgot password?
        </div>
        <Button
          text="LOGIN"
          class={`OtpButton mt-4 ${isLoading && ''}`}
          isDisabled={isLoading}
          isLoading={isLoading}
        />
      </form>
      <p className="new-sign-in-para divider">
        <span>OR WITH</span>
      </p>
      <div className="row">
        <div className="col-6">
          <GoogleLogin
            isLoading={isLoading}
            section={'Login'}
            plan_id={props.plan_id}
          />
        </div>
        <div className="col-6">
          <AppleLogin
            isLoading={isLoading}
            section={'Login'}
            plan_id={props.plan_id}
            handleModalState={handleModalState}
          />
        </div>
      </div>
    </div>
  );
};

EmailModal.propTypes = {
  countryCode: PropTypes.string,
  handleModalState: PropTypes.func,
  page: PropTypes.string,
  plan_id: PropTypes.string,
  handleClose: PropTypes.func,
  processOfflineCart: PropTypes.func,
};

export default EmailModal;
